<template>
  <div class="edit-container">
    <div ref="editable" contenteditable v-on:input="onInput"></div>
    <div class="placeholder" v-if="showPlaceHolder">{{placeholder}}</div>
  </div>
</template>

<script>

export default {
    props: {
      value: {
        type: String,
        default: '',
      },
      placeholder: {
        type:String
      }
    },
    computed: {
      showPlaceHolder() {
        return this.value === '';
      }
    },
    mounted() {
      this.$refs.editable.innerText = this.value;
    },
    methods: {
      onInput(e) {
        this.$emit('input', e.target.innerText);
      },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .edit-container {position:relative;}

  div[contenteditable] { border: 0px; border-bottom: 1px solid #DDDDDD; max-height: 200px; overflow: auto; padding: 6px 2px 8px 2px; position: relative; z-index: 2; min-height: 32px; }
  div[contenteditable]:focus { border-bottom: 1px solid #444444; }
  .placeholder {position:absolute;z-index:1;top:6px;left:2px;color:#999999;}
</style>



// WEBPACK FOOTER //
// Editable.vue?5754556d